import React, { Component } from 'react';
import Checkbox from '../../../Checkbox';
import Icon from '../../../Icon';
// import { EditorState, convertFromHTML, convertFromRaw, ContentState } from 'draft-js';
import TextEditor from '../../../Editor/Editor';
import { S3BucketConfig } from '../../../../common/constants';

export default class Checklist extends Component {
    render() {
      const { checklist, onChangeChecklistStatus, isAddNote, isAddDocument, onDeleteCreatedDoc, onUpdateDeleteChecklistNote, user } = this.props;
      return (
    checklist && checklist.length > 0 ?
        checklist.map((cl) => {
            let subTitle = cl.subTitle ? cl.subTitle.replace(/<[^>]+>/g, '') : '';
            let notes = cl.suiteOnBoardingChecklistNotes;
            let sTitle = cl.subTitle ? cl.subTitle : ""
            let note = notes && notes.length > 0 && notes[0].description ? notes[0].description : ""

            // if(notes && notes.length > 0) {
            //     const blocksFromHTML = convertFromHTML(notes[0].description);
            //     const cstate = ContentState.createFromBlockArray(
            //       blocksFromHTML.contentBlocks,
            //       blocksFromHTML.entityMap,
            //     );
            //     note = EditorState.createWithContent(cstate);
            // }
            // if (cl.subTitle) {
            //     const blocksFromHTML = convertFromHTML(cl.subTitle);
            //     const cstate = ContentState.createFromBlockArray(
            //       blocksFromHTML.contentBlocks,
            //       blocksFromHTML.entityMap,
            //     );
            //     sTitle = EditorState.createWithContent(cstate);
            //     }
                
            return (
                <div className='checkBox'>
                    <Checkbox
                        value={cl.ischecked}
                        label={cl.title}
                        onChange={() => user.roles[0].role.name !== "Realtor" ?onChangeChecklistStatus(cl):null}
                    />
                       <TextEditor 
                            editorState={sTitle}
                            readOnly={true}
                            toolbarHidden={true}
                          />
                    {cl.ischecked && cl.suiteOnBoardingChecklistNotes.length > 0 &&
                        <div className='notesSection'>
                            <div className='notesHedding'>
                                Added Notes :
                            </div>
                            <div className='notesContent'>
                            <TextEditor 
                            editorState={note}
                            readOnly={true}
                            toolbarHidden={true}
                          />
                          {
                           user.roles[0].role.name !== "Realtor"? 
                           <span style={{paddingLeft: 5}} onClick={() => onUpdateDeleteChecklistNote(cl.suiteOnBoardingChecklistNotes[0], 'update')}>
                                <Icon
                                 glyph="pencil"
                                 weight="light"
                               /></span>
                               :null
                          }
                               
                            </div>
                        </div>}
                    {cl.ischecked && cl.suiteOnBoardingChecklistDocuments.length > 0 &&
                        <>
                        <div className='uploadSection'>
                            <div className='uploadHedding'>
                                Uploaded Documents :
                            </div>
                            <>
                                {cl.suiteOnBoardingChecklistDocuments.map((doc) => {
                                    return (
                                        <div className='uploadContent'>
                                          {/* <img src='https://dummyimage.com/32x32/000/fff' alt='' /> */}
                                           <div className='imgPath'> {doc.url && doc.url.split(S3BucketConfig)[1]}
                                          {
                                            user.roles[0].role.name !== "Realtor"?
                                            <a onClick={() => window.confirm(`Are you sure you want to delete document?`) && onDeleteCreatedDoc(doc)}>
                                            <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M5.00028 0C5.51343 -4.01399e-07 6.00695 0.197228 6.37876 0.550892C6.75057 0.904556 6.97223 1.3876 6.99789 1.90011L7.00039 2.00011H9.50053C9.62797 2.00025 9.75056 2.04905 9.84323 2.13654C9.9359 2.22403 9.99167 2.34361 9.99914 2.47083C10.0066 2.59806 9.96522 2.72334 9.88342 2.82107C9.80162 2.9188 9.68559 2.98161 9.55903 2.99667L9.50053 3.00017H9.076L8.48597 10.2771C8.44791 10.7466 8.23448 11.1847 7.88815 11.504C7.54183 11.8234 7.08797 12.0007 6.61687 12.0007H3.38369C2.91258 12.0007 2.45873 11.8234 2.1124 11.504C1.76607 11.1847 1.55265 10.7466 1.51458 10.2771L0.924051 3.00017H0.500028C0.377554 3.00015 0.259346 2.95519 0.167823 2.8738C0.0763008 2.79242 0.0178296 2.68027 0.00350018 2.55864L0 2.50014C1.61562e-05 2.37766 0.0449805 2.25946 0.126365 2.16793C0.207749 2.07641 0.319892 2.01794 0.441524 2.00361L0.500028 2.00011H3.00017C3.00017 1.46965 3.21089 0.960912 3.58599 0.585819C3.96108 0.210725 4.46981 0 5.00028 0ZM3.87521 4.62526C3.78459 4.62526 3.69703 4.65808 3.62874 4.71764C3.56044 4.77721 3.51602 4.85949 3.50369 4.94927L3.50019 5.00028V9.0005L3.50369 9.0515C3.51604 9.14126 3.56047 9.22352 3.62877 9.28306C3.69707 9.3426 3.78461 9.3754 3.87521 9.3754C3.96582 9.3754 4.05336 9.3426 4.12166 9.28306C4.18996 9.22352 4.23439 9.14126 4.24674 9.0515L4.25024 9.0005V5.00028L4.24674 4.94927C4.23441 4.85949 4.18999 4.77721 4.12169 4.71764C4.0534 4.65808 3.96584 4.62526 3.87521 4.62526ZM6.12534 4.62526C6.03472 4.62526 5.94716 4.65808 5.87886 4.71764C5.81056 4.77721 5.76614 4.85949 5.75382 4.94927L5.75032 5.00028V9.0005L5.75382 9.0515C5.76617 9.14126 5.8106 9.22352 5.87889 9.28306C5.94719 9.3426 6.03473 9.3754 6.12534 9.3754C6.21595 9.3754 6.30349 9.3426 6.37178 9.28306C6.44008 9.22352 6.48451 9.14126 6.49686 9.0515L6.50036 9.0005V5.00028L6.49686 4.94927C6.48454 4.85949 6.44012 4.77721 6.37182 4.71764C6.30352 4.65808 6.21596 4.62526 6.12534 4.62526ZM5.00028 1.00006C4.74797 0.999975 4.50497 1.09526 4.31997 1.26682C4.13496 1.43837 4.02164 1.67351 4.00272 1.92511L4.00022 2.00011H6.00033L5.99783 1.92511C5.97891 1.67351 5.86559 1.43837 5.68059 1.26682C5.49559 1.09526 5.25258 0.999975 5.00028 1.00006Z" fill="#EB5757" />
                                            </svg>
                                          </a>
                                            :null
                                          }
                                           </div>
                                        </div>
                                    )
                                })}
                            </>
                            </div>
                        </>
                    }
                    {
                        
                    }
                {
                    user.roles[0].role.name !== "Realtor"?    
                    <div className='addNoteButton'>
                    {cl.ischecked && cl.suiteOnBoardingChecklistNotes.length === 0 &&
                        <button className='btn first' onClick={() => isAddNote(cl)}>Add Notes</button>}
                    {/* {cl.ischecked && cl.suiteOnBoardingChecklistDocuments.length === 0 && */}
                    {cl.ischecked &&
                        <button className='btn first' onClick={() => isAddDocument(cl)}>Upload Document</button>}
                    </div>
                    :null
                }

                </div>
            )
        }) :
        <div>No checklists found.</div>
      )
    }
}
